module.exports = __webpack_public_path__ + "img/generic-user.be5801e2.jpg";